<template>
	<div class="award">
		<form class="award__table award__add" @submit.prevent="addCategory">
			<table class="simple-table">
				<thead>
					<tr>
						<th
							v-for="(title, index) in categoryNameList"
							:key="index"
							class="award__table__head"
						>
							{{ title }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="categoryName !== 'mappingProduct'">
						<td class="award__table__data">
							<template>
								<input
									placeholder="1차카테고리명"
									type="text"
									v-if="categoryName === 'firstCategory'"
									v-model="firstCategoryName"
								/>
								<span v-else>{{ firstCategoryText }}</span>
							</template>
						</td>
						<template>
							<td
								v-if="categoryName === 'firstCategory'"
								class="award__table__summary"
							>
								<textarea
									type="text"
									placeholder="총평"
									v-model="summaryData"
									rows="5"
								></textarea>
							</td>
							<td v-else class="award__table__data">
								<template>
									<input
										placeholder="2차카테고리명"
										type="text"
										v-if="categoryName === 'secondCategory'"
										v-model="secondCategoryName"
									/>
									<span v-else>{{ secondCategoryText }}</span>
								</template>
							</td>
						</template>
						<td
							v-if="categoryName === 'firstCategory'"
							class="award__table__image"
						>
							<input
								placeholder="어워드 모듈 이미지"
								type="file"
								ref="awardModule"
								@change="
									handleFileChange($event, 'awardModule')
								"
							/>
						</td>
						<td
							v-if="categoryName === 'thirdCategory'"
							class="award__table__data"
						>
							<input
								placeholder="3차카테고리명"
								type="text"
								v-model="thirdCategoryName"
							/>
						</td>
						<td
							v-if="categoryName === 'thirdCategory'"
							class="award__table__mapping"
						>
							<div class="category__seletor__list">
								<div class="category__selector__box">
									<CategorySelector
										@change="getThirdCategoryName($event)"
										:award="true"
									/>
									<div class="category__button-wrapper">
										<button
											@click="addTarget"
											class="category__add"
										>
											<i class="fa fas fa-plus" />
										</button>
									</div>
								</div>
								<div class="category__seletor">
									<div
										v-for="(name, idx) in thirdCategoryList"
										:key="idx"
										class="category__list"
									>
										<span>{{ name }}</span>
										<button
											class="category__name remove"
											@click="removeProductCategory(idx)"
										>
											<i class="fa fas fa-minus"></i>
										</button>
									</div>
								</div>
							</div>
						</td>
						<td class="award__table__order">
							<input
								type="text"
								placehoder="정렬순서"
								v-model="sortNumber"
							/>
						</td>
						<td class="award__table__btn">
							<button
								class="btn blue"
								@click="addCategory"
								type="button"
							>
								등록
							</button>
						</td>
					</tr>
					<tr v-else>
						<td class="award__table__product">
							<div class="product">
								<ProductSearcher2 @change="idProductChange" />
								<div class="product__name" v-if="productName">
									<div>{{ productName }}</div>
									<button
										type="button"
										class="product__name remove"
										@click="removeProduct"
									>
										<i class="fa fas fa-minus" />
									</button>
								</div>
							</div>
						</td>
						<td class="award__table__data">
							<DateBox v-model="reviewStartDate" type="date" />
						</td>
						<td class="award__table__data">
							<DateBox v-model="reviewEndDate" type="date" />
						</td>
						<td class="award__table__order">
							<input
								type="text"
								placehoder="순위라벨"
								v-model="sortNumber"
							/>
						</td>
						<td class="award__table__btn">
							<button
								type="submit"
								class="btn blue"
								v-text="'등록'"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</form>
	</div>
</template>
<script>
	import DateBox from '@/components/DateBox';
	import ProductSearcher2 from '@/components/ProductSearcher2';
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import CategorySelector from '@/components/common/CategorySelector';
	import { imageUpload } from '@/util';

	export default {
		data() {
			return {
				firstCategoryHead: [
					'1차 카테고리',
					'총평',
					'어워드모듈 배경이미지 (1080 x 1350)',
					'정렬순서',
					'추가',
				],
				secondCategoryHead: [
					'1차 카테고리',
					'2차 카테고리',
					'정렬순서',
					'추가',
				],
				thirdCategoryHead: [
					'1차 카테고리',
					'2차 카테고리',
					'3차 카테고리',
					'제품 카테고리',
					'정렬순서',
					'추가',
				],
				mappingProductHead: [
					'제품',
					'리뷰 시작일',
					'리뷰 종료일',
					'순위라벨',
					'추가',
				],
				firstCategoryName: '',
				summaryData: '',
				secondCategoryName: '',
				thirdCategoryName: '',
				sortNumber: '',
				reviewStartDate: '',
				reviewEndDate: '',
				productName: '',
				productId: '',
				thirdCategoryProduct: [],
				thirdCategoryIds: [],
				thirdCategoryList: [],
				thirdProductIds: '',
				selectedCategory: {},
				fileDir: '',
				fileSaveName: '',
			};
		},
		props: {
			categoryName: {
				type: String,
				default: 'firstCategory',
			},
			awardId: {
				type: Number,
				default: 0,
			},
			firstCategoryText: {
				type: String,
				default: '-',
			},
			secondCategoryText: {
				type: String,
				default: '-',
			},
			thirdCategoryText: {
				type: String,
				default: '-',
			},
		},
		components: {
			ProductSearcher2,
			DateBox,
			CategorySelector,
		},
		watch: {
			$route(to, from) {
				if (to.path !== from.path) {
					this.init();
				}
			},
		},
		computed: {
			...mapGetters({
				getThirdCategory: 'getThirdCategory',
			}),
			categoryNameList() {
				switch (this.categoryName) {
					case 'firstCategory':
						return [...this.firstCategoryHead];
					case 'secondCategory':
						return [...this.secondCategoryHead];
					case 'thirdCategory':
						return [...this.thirdCategoryHead];
					case 'mappingProduct':
						return [...this.mappingProductHead];
					default:
						break;
				}
			},
		},
		methods: {
			init() {
				this.firstCategoryName = '';
				this.secondCategoryName = '';
				this.summaryData = '';
				this.sortNumber = '';
				this.thirdCategoryName = '';
				this.productName = '';
				this.reviewEndDate = '';
				this.reviewStartDate = '';
				this.thirdCategoryIds = [];
				this.thirdProductIds = -1;
				this.thirdCategoryList = [];
				if (this.$refs.awardModule) {
					this.$refs.awardModule.value = '';
				}
				this.fileDir = '';
				this.fileSaveName = '';
			},
			removeProduct() {
				this.productName = '';
			},

			async addCategoryMapping(endPoint, params, action, actionParams) {
				if (isNaN(this.sortNumber))
					return alert('정렬순서는 숫자만 가능합니다.');
				if (!confirm('정말 등록하시겠습니까?')) return;
				try {
					await this.$axiosAdmin2.post(endPoint, params);
					alert('성공적으로 등록하였습니다.');
					this.init();
					await this.$store.dispatch(action, actionParams);
				} catch (err) {
					console.error(err);
					alert(
						'등록에 실패하였습니다. 지속적으로 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},

			async addFirstCategory() {
				const endPoint = `/api/award/firstcategory/${this.awardId}`;
				const action = 'award/getFirstCategory';
				const actionParams = this.awardId;
				const params = {
					categoryText: this.firstCategoryName,
					categorySummary: this.summaryData,
					sortKey: Number(this.sortNumber),
					moduleFirstCategoryFileDir: this.fileDir,
					moduleFirstCategoryFileSaveName: this.fileSaveName,
				};
				if (!this.firstCategoryName)
					return alert('1차 카테고리명을 입력해주세요');
				if (!this.summaryData) return alert('총평을 입력해주세요');
				this.addCategoryMapping(endPoint, params, action, actionParams);
			},

			async addSecondCategory() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				const params = {
					categoryText: this.secondCategoryName,
					sortKey: Number(this.sortNumber),
				};
				const endPoint = `/api/award/secondcategory/${idHitProduct}/${idHitCategory}`;
				const action = 'award/getSecondCategory';
				const actionParams = { idHitProduct, idHitCategory };

				if (!this.secondCategoryName)
					return alert('2차 카테고리명을 입력해주세요');

				this.addCategoryMapping(endPoint, params, action, actionParams);
			},
			async addThirdCategory() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				const params = {
					categoryText: this.thirdCategoryName,
					sortKey: Number(this.sortNumber),
					thirdCategoryIds: this.thirdCategoryIds,
				};
				const endPoint = `/api/award/thirdcategory/${idHitProduct}/${idHitCategory}`;
				const action = 'award/getThirdCategory';
				const actionParams = { idHitProduct, idHitCategory };

				if (!this.thirdCategoryName)
					return alert('3차 카테고리명을 입력해주세요');

				this.addCategoryMapping(endPoint, params, action, actionParams);
			},

			removeProductCategory(idx) {
				this.thirdCategoryIds.splice(idx, 1);
				this.thirdCategoryList.splice(idx, 1);
				this.thirdProductIds = '';
			},

			async addMappingProduct() {
				const { idHitProduct, idHitCategory } = this.$route.query;
				const params = {
					rankLabel: Number(this.sortNumber),
					idProduct: this.productId,
					startDate: moment(this.reviewStartDate).format('YYYYMMDD'),
					endDate: moment(this.reviewEndDate).format('YYYYMMDD'),
				};
				const endPoint = `/api/award/thirdcategory/${idHitProduct}/${idHitCategory}/product-mappings`;
				const action = 'award/getMappinCategory';
				const actionParams = { idHitProduct, idHitCategory };

				if (!this.productName) return alert('제품명을 입력해주세요');
				if (!this.reviewStartDate || !this.reviewEndDate)
					return alert('날짜를 정확하게 입력해 주세요');
				if (
					moment(this.reviewStartDate).valueOf() >
					moment(this.reviewEndDate).valueOf()
				)
					return alert('리뷰종료일이 리뷰시작일 이전입니다.');

				this.addCategoryMapping(endPoint, params, action, actionParams);
			},

			idProductChange(id) {
				this.productName = id?.name;
				this.productId = id?.idProduct;
			},
			addCategory() {
				if (this.categoryName === 'firstCategory') {
					this.addFirstCategory();
				}
				if (this.categoryName === 'secondCategory') {
					this.addSecondCategory();
				}
				if (this.categoryName === 'thirdCategory') {
					this.addThirdCategory();
				}
				if (this.categoryName === 'mappingProduct') {
					this.addMappingProduct();
				}
			},
			addTarget() {
				if (this.selectedCategory) {
					if (
						this.thirdCategoryList.indexOf(
							this.selectedCategory.value
						) !== -1
					) {
						alert('이미 리스트에 포함되어 있습니다.');
						return;
					}
					this.thirdCategoryList.push(this.selectedCategory.value);
					this.thirdCategoryIds.push(this.selectedCategory.id);
				} else {
					alert('3차 카테고리가 없습니다');
				}
			},
			getThirdCategoryName(id) {
				this.selectedCategory = id?.c3;
			},
			readFile(file) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const file = new Image();
						file.src = e.target.result;

						file.onload = () => {
							const width = file.width;
							const height = file.height;

							const setWidth = 1080;
							const setHeight = 1350;

							if (setWidth !== width || setHeight !== height) {
								alert(
									`이미지 사이즈가  ${setWidth} x ${setHeight}가 아닙니다`
								);
								this.$refs.awardModule.value = '';
								this.fileDir = '';
								this.fileSaveName = '';
								return;
							}
							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},
			addImg(urlList, files) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0]);
			},
			async uploadImage(imageObj) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'award-module',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					this.fileDir = imgPath;
					this.fileSaveName = fileSaveName;
				} catch (err) {
					console.error(err);
				}
			},
			async handleFileChange(event) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files);
			},
		},
	};
</script>
<style lang="scss" scoped>
	#app-main {
		.award {
			&__table {
				margin-top: 20px;
				.simple-table {
					th {
						text-align: center;
						padding: 0;
					}
				}
			}
			&__add {
				display: flex;
				flex-direction: column;
				justify-content: center;
				margin: 50px auto 0;
				max-width: 1500px;
				.simple-table {
					th {
						background: linear-gradient(
							to top,
							#d3e1f1,
							#f4f7fa,
							#f4f7fa
						);
						border: solid 1px #d5dde6;
					}
				}
			}
			&__tabel__summary {
				width: 100px;
			}
			&__table__data {
				width: 20%;
				text-align: center;
			}
			&__table__category {
				width: 5%;
			}
			&__table__product {
				width: 50%;
				text-align: center;
			}
			&__table__mapping {
				width: 33%;
				text-align: center;
			}
			.product {
				margin-top: 0;
				input {
					font-size: 10px;
				}
			}
			&__table__order {
				width: 50px;
			}
			&__table__btn {
				width: 10%;
				text-align: center;
				padding: 0 50px;
			}
			&__table__head {
				text-align: center;
				padding: 0;
			}

			&__table__image {
				width: 300px;
			}
		}
		.product__name {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 20px;
			width: 100%;
			&.remove {
				background: #ff3860;
				font-size: 0.75rem;
				vertical-align: middle;
				width: 1.6em;
				height: 1.6em;
				border-radius: 50%;
				color: #fff;
				margin: 0 0 0 10px;
			}
		}
		.category__name {
			&.remove {
				background: #ff3860;
				font-size: 0.75rem;
				vertical-align: middle;
				width: 1.6em;
				height: 1.6em;
				border-radius: 50%;
				color: #fff;
				margin: 0 0 0 10px;
			}
		}
		.category__seletor {
			.category__list {
				margin-top: 10px;
				padding: 5px;
				border: 1px solid #e8e5e5;
				display: inline-block;
				border-radius: 10px;
				& + .category__list {
					margin-left: 3px;
				}
			}
		}
		.category__selector__box {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.category__button-wrapper {
			text-align: center;
			padding-left: 10px;
		}

		.category__add {
			background: $btn-blue;
			width: 1.6em;
			height: 1.6em;
			border-radius: 50%;
			color: #fff;
		}
	}
</style>
